import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import ActionButton from "@/components/base/ActionButton";
import { solutions } from "@/mocks/solutions";

export default function SolutionsPreview() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <SectionHeading
              eyebrow="EV Retrofit Solutions"
              title="Retrofit Solutions Built Around the Vehicle You Already Own"
              description="Solutions are organised by vehicle category and application. In every category, final feasibility depends on vehicle condition, architecture, weight, usage and engineering assessment."
            />
            <div className="shrink-0">
              <ActionButton to="/ev-retrofit#eligibility" variant="primary" size="lg" icon="ri-flashlight-line">
                Check Your Vehicle
              </ActionButton>
            </div>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {solutions.map((item, index) => (
            <Reveal key={item.key} delay={index * 0.05}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition-colors duration-300 hover:border-primary-300">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                  <i className={`${item.icon} text-2xl`} />
                </span>
                <h3 className="mt-5 text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
                <p className="mt-4 rounded-md bg-background-200/70 px-3 py-2 text-[11px] leading-relaxed text-foreground-600">
                  Feasibility depends on vehicle condition, architecture, weight, usage and
                  engineering assessment.
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-wrap gap-3">
            <ActionButton to="/solutions" variant="dark" size="md" iconRight="ri-arrow-right-line">
              View All Solutions
            </ActionButton>
            <ActionButton to="/technology" variant="outline" size="md">
              Explore the Technology
            </ActionButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}